module.exports = __webpack_public_path__ + "static/media/reactjs.6d51a9c0.jpg";